import { Component, ElementRef, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import * as moment from 'moment';

import { Observable } from 'rxjs';

import { Antwoord, Vraag } from '@models/claims';
import { IBaseVraagboomResultaat, VraagboomAntwoord, VraagboomTimeResultaat } from '@models/vragenboom';
import { FormatHelper } from '@services/public_api';
import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { DataService } from '../../../services/data.service';
import { TimeValidator } from '../../../utils/validation/time.validator';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
  providers: [],
  encapsulation: ViewEncapsulation.None,
})
export class TimePickerComponent extends BaseVraagControlDirective<VraagboomTimeResultaat> implements OnInit {
  @ViewChild('textBoxField', { static: true }) textBoxElement: ElementRef;
  placeholder = '00:00';
  errormessageText: string;
  errormessageTextFuture = 'Je koos een tijdstip in de toekomst, kies een andere tijd.';
  validatieErrorFuture = false;
  tijdHadFocus = false;
  timeOpen = false;
  textboxEvent = false;
  validTime = false;
  lastValidTime = '';
  resultaten$: Observable<VraagboomAntwoord<IBaseVraagboomResultaat>[]>;
  resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[];
  tijden: string[];

  _tekst: string;
  get tekst(): string {
    return this._tekst;
  }
  set tekst(val: string) {
    this._tekst = val;
  }

  constructor(_dataService: DataService) {
    super(_dataService);
  }

  ngOnInit() {
    this.tijden = [];
    for (let u = 0; u < 24; u++) {
      for (let m = 0; m < 60; m = m + 30) {
        this.tijden.push(FormatHelper.formatTime(u, m));
      }
    }

    if (this.vraag?.antwoorden?.length > 0) {
      this.errormessageText = this.vraag.antwoorden[0].foutmelding;
    }
    this.resultaten$ = this._dataService.resultaten;
    this.resultaten$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        if (res !== undefined && res !== null) {
          this.resultaten = res;
        }
      });
  }

  initialize(changes: SimpleChanges): void {
    if (this.vraag?.antwoorden?.length > 0 && this.antwoordResultaat?.resultaat != null) {
      this._tekst = this.antwoordResultaat.resultaat.tijd;
      this.checkTijd();
    } else {
      this._tekst = '';
    }
  }

  notifyAntwoord() {
    const antwoorden: Antwoord[] = [];
    if (this.vraag?.antwoorden?.length > 0) {
      antwoorden.push(this.vraag.antwoorden[0]);
    }
    var tekstSplit = this._tekst.split(':');
    this.setAntwoord(antwoorden, new VraagboomTimeResultaat(Number(tekstSplit[0]), Number(tekstSplit[1])));
  }

  isTijdLeeg(): boolean {
    return (this._tekst == null) || (this._tekst.length === 0);
  }

  checkTijd() {
    const re = new RegExp('^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$');
    const re2 = new RegExp('^(0[0-9]|1[0-9]|2[0-3])[0-5][0-9]$');

    // check of voorloopnul ontbreekt
    if (this._tekst.replace(':', '').length === 3) {
      this._tekst = '0' + this._tekst;
    }

    if (this._tekst && re.test(this._tekst)) {
      this.validTime = true;
      this.lastValidTime = this._tekst;
      this.notifyAntwoord();
    } else {
      // check of tijd zonder : is
      if (this._tekst && re2.test(this._tekst)) {
        this._tekst = this._tekst.substr(0, 2) + ':' + this._tekst.substr(2);
        this.validTime = true;
        this.lastValidTime = this._tekst;
        this.notifyAntwoord();
      } else {
        this._tekst = this.lastValidTime;
        this.validTime = this.lastValidTime?.length > 0;
      }
    }
  }

  setTextFocus(focus: boolean) {
    this.textboxEvent = true;
    if (focus) {
      this.timeOpen = false;
    } else {
      this.tijdHadFocus = true;
      this.checkTijd();
    }
    this.textboxEvent = false;
  }

  selectTime(tijd: string) {
    this._tekst = tijd;
    this.lastValidTime = tijd;
    this.validTime = true;
    this.timeOpen = false;
    this.tijdHadFocus = true;
    this.notifyAntwoord();
  }

  toggleTime(): void {
    this.timeOpen = !this.timeOpen;
  }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomTimeResultaat): boolean {
    if (!this.isTijdLeeg() && this.validTime && !TimeValidator.isValidFuture(antwoorden[0], resultaat, this.resultaten)) {
      this.validatieErrorFuture = true;
    } else {
      this.validatieErrorFuture = false;
    }
    if (this.isTijdLeeg() || !this.validTime) {
      return false;
    }
    return (antwoorden?.length === 1) && TimeValidator.isValidTime(antwoorden[0], resultaat, this.resultaten);
  }
}
